const ONBOARDING_STORAGE_PREFIX = "aioscp_onboarding_completed:";

function storageKey(tenantId: string): string {
  return `${ONBOARDING_STORAGE_PREFIX}${tenantId}`;
}

export function getOnboardingCompleted(tenantId: string): boolean {
  try {
    return localStorage.getItem(storageKey(tenantId)) === "true";
  } catch {
    return false;
  }
}

export function setOnboardingCompleted(tenantId: string, completed: boolean): void {
  try {
    if (completed) {
      localStorage.setItem(storageKey(tenantId), "true");
    } else {
      localStorage.removeItem(storageKey(tenantId));
    }
  } catch {
    // Ignore storage failures in restrictive environments.
  }
}
